/**
 * check for minimum order quantity
 * @param {number} qty
 * @param {number} minOrderVal
 * @returns {boolean}
 */
const isMinOrderQuantityValid = (qty, minOrderVal) =>
  qty % minOrderVal !== 0 || qty <= 0;

/**
 * check for maximum order quantity
 * @param {number} qty
 * @param {number} maxOrderVal
 * @returns {boolean}
 */
const isMaxOrderQuantityValid = (qty, maxOrderVal) => qty > maxOrderVal;

/**
 * Check if error response contains the errors we want to show
 * @param {string} key
 * @returns {string|boolean}
 */
const isQuantitySelectorError = key => {
  const validErrorKeys = [
    'not_divisible_by_min_order',
    'greater_than_max_quantity',
  ];

  if (validErrorKeys.includes(key)) return key;
  return false;
};

/**
 * Set the basket in the header to the loading state
 */
const setBasketHeaderLoading = () =>
  document
    .querySelector('.basket-preview-price-wrapper')
    .classList.add('is-loading');

/**
 * TODO: when PIUX-261/Epic-quick_order is merged - delete duplicates from lib/utils
 * Method to create a JSON object to send to the basket endpoint
 * @param {*} products - list of products with ids + quantity
 * @returns
 */
const createBasketJSON = (products, isReserveCollect, skipBackOrderCheck) => {
  const lines = {};
  products.forEach(({ product_id: id, quantity }, index) => {
    lines[index] = {
      product_id: id,
      quantity: +quantity,
    };
  });

  const basket = {
    basket: {
      lines_attributes: lines,
      skip_back_order_check: skipBackOrderCheck || 'true',
    },
    commit: isReserveCollect ? 'Reserve & Collect' : '',
  };
  return basket;
};

/**
 * TODO: when PIUX-261/Epic-quick_order is merged - delete duplicates from lib/utils
 * method to update the basket in header with the new basket quantities + price
 * @param {Object} data - the new basket count/price
 * @param {Function} callback - callback when timeout is complete
 */
const displaySuccessfulUpdate = (data, callback) => {
  setTimeout(() => {
    const basketInfoWrapper = document.querySelector(
      '.basket-preview-price-wrapper',
    );
    const basketItems = basketInfoWrapper.querySelector('.basket-items');
    const basketPreviewPrice = basketInfoWrapper.querySelector(
      '.basket-preview-price',
    );
    const basketCount = basketInfoWrapper.querySelector('.basket-count');
    basketInfoWrapper.classList.remove('is-loading');

    if (data) {
      basketItems.innerHTML = data.lines;
      basketPreviewPrice.innerHTML = data.total;
      if (basketCount) {
        basketCount.innerHTML = data.mobile_count;
      }
    }

    if (callback) {
      callback();
    }
  }, 2500);
};

const addToBasketTracking = data => {
  if (window.dataLayer) {
    const { stockCode, stepId, price, title, brand, category } = data;

    window.dataLayer.push({
      event: 'addBasket',
      ecommerce: {
        currencyCode: 'GBP',
        add: {
          products: [
            {
              id: stockCode,
              name: title,
              price,
              brand: brand || '',
              category,
              quantity: 1,
              'id-variant': stepId,
            },
          ],
        },
      },
    });
  }
};

const linkToCollection = (stepId, qty, address) => {
  const baseUrl = '/basket/collections/new';
  const params = [];

  if (stepId) {
    params.push(`product_id=${stepId}`);
  }

  if (qty) {
    params.push(`quantity=${parseFloat(qty)}`);
  }

  if (address) {
    params.push(`address=${address}`);
  }

  return `${baseUrl}?${params.join('&')}`;
};

export {
  isMinOrderQuantityValid,
  isMaxOrderQuantityValid,
  isQuantitySelectorError,
  setBasketHeaderLoading,
  createBasketJSON,
  displaySuccessfulUpdate,
  addToBasketTracking,
  linkToCollection,
};
